export default __webpack_public_path__ + "static/media/download.52e6d6c5.png";